import type {CandidateMatchingState} from 'src/reducers/candidate-matching';


export const RECEIVE_CANDIDATE_MATCHING_INFO = 'candidate-matching/receive';
export const UPDATE_CANDIDATE_MATCHING_INFO = 'candidate-matching/update';
export const RESET_CANDIDATE_MATCHING_INFO = 'candidate-matching/reset';

type CandidateMatchingPayload = Partial<CandidateMatchingState>;

type ReceiveCandidateMatchingInfo = {
  type: typeof RECEIVE_CANDIDATE_MATCHING_INFO;
  payload: CandidateMatchingPayload;
};

type UpdateCandidateMatchingInfo = {
  type: typeof UPDATE_CANDIDATE_MATCHING_INFO;
  payload: CandidateMatchingPayload;
};

type ResetStateAction = {
  type: typeof RESET_CANDIDATE_MATCHING_INFO;
};

export type CandidateMatchingAction =
  | ReceiveCandidateMatchingInfo
  | UpdateCandidateMatchingInfo
  | ResetStateAction;

export const receiveCandidateMatchingInfo = (
  payload: CandidateMatchingState,
): ReceiveCandidateMatchingInfo => ({
  type: RECEIVE_CANDIDATE_MATCHING_INFO,
  payload,
});

export const updateCandidateMatchingInfo = (
  payload: CandidateMatchingPayload,
): UpdateCandidateMatchingInfo => ({
  type: UPDATE_CANDIDATE_MATCHING_INFO,
  payload,
});
export const resetCandidateMatchingInfo = (): ResetStateAction => ({
  type: RESET_CANDIDATE_MATCHING_INFO,
});
